export default function () {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;

  $(`#${widgetName}`).append('<iframe></iframe>');
  $(`#${widgetName}`).wrap('<div id="videoSection"></div>');
  $(`#${widgetName}`).videoWidget({

    scriptPath: widgetOpts.scriptPath
    , currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID
    , detectIpad: IPADDETECTED
    // options
    , multiVideo: false
    , showOnMobile: true
    , maxVideos: 1
    , autoPlayVideo: true
    , loopVideo: true
    , trackingGA: {
      present: false,
      event: 'event',
      gaObj: {
        eventCategory: 'Videos',
        eventAction: '',
        eventLabel: '',
        loopVideo: true
      }
    }
    , videoWidgetLoaded: function (data) {

      if (data.Slides.length < 1) {
        setTimeout(() => {
          $(".video-border").addClass("hidingComponent")
          $(".card-content").addClass("alignment-novideo")
          $(".video-seo").addClass("padding-novideo")

        }, 100)
      }
    }
  });
};
